import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { IAssessment } from '../../../../shared/models/assessment';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { IUserInfo } from '../../../../shared/models/contact';
import { UserDataService } from '../../../../shared/services/userData.service';
declare var initFlowbite: any;

@Component({
  selector: 'assess-details',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule
  ],
  templateUrl: './assess-details.component.html',
  styleUrl: './assess-details.component.css'
})
export class AssessDetailsComponent implements OnInit {
  icons = Icons;
  currentUser: IUserInfo | null = null;

  @Input() asessDetails: IAssessment | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userDataService.getUserData();
    // Initialize Flowbite 
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        initFlowbite();
      }
    }, 50);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  deleteAssess(): void {
    if (this.asessDetails) {
      this.onDelete.emit();
    } else {
      console.error('Cannot delete: assessDetails is null or undefined.');
    }
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }
}
